import React from 'react';
import { Link } from 'react-router-dom';

// Import des icônes sociales
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube } from 'react-icons/fa';

const Footer = () => {
  // Liens sociaux - tu remplaceras les URLs par les bonnes
  const socialLinks = [
    { name: 'Facebook', icon: FaFacebookF, url: 'https://facebook.com/votrecompte', color: '#1877F2' },
    { name: 'Twitter', icon: FaTwitter, url: 'https://twitter.com/votrecompte', color: '#1DA1F2' },
    { name: 'Instagram', icon: FaInstagram, url: 'https://instagram.com/votrecompte', color: '#E4405F' },
    { name: 'LinkedIn', icon: FaLinkedinIn, url: 'https://linkedin.com/company/votrecompte', color: '#0A66C2' },
    { name: 'YouTube', icon: FaYoutube, url: 'https://youtube.com/@votrecompte', color: '#FF0000' },
  ];

  return (
    <footer className="bg-[#0a0a0a] border-t border-[#252525]">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Marque */}
          <div>
            <h3 className="text-2xl font-display font-bold text-[#F97316] mb-4">VADOM</h3>
            <p className="text-[#AAAAAA] mb-4">
              La plateforme qui connecte prestataires et clients au Togo et en Afrique de l'Ouest.
              Simple, rapide, sécurisé.
            </p>
            <div className="flex space-x-3">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-full bg-[#1a1a1a] flex items-center justify-center text-[#AAAAAA] hover:text-white transition-all duration-300 hover:scale-110"
                  style={{ '--hover-color': social.color }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = social.color}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#1a1a1a'}
                >
                  <social.icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-semibold text-white mb-4">Navigation</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-[#AAAAAA] hover:text-[#F97316] transition">Accueil</Link></li>
              <li><Link to="/services" className="text-[#AAAAAA] hover:text-[#F97316] transition">Services</Link></li>
              <li><Link to="/become-smart" className="text-[#AAAAAA] hover:text-[#F97316] transition">Devenir Smart</Link></li>
              <li><Link to="/contact" className="text-[#AAAAAA] hover:text-[#F97316] transition">Contact</Link></li>
              <li><Link to="/about" className="text-[#AAAAAA] hover:text-[#F97316] transition">À propos</Link></li>
              <li><Link to="/faq" className="text-[#AAAAAA] hover:text-[#F97316] transition">FAQ</Link></li>
            </ul>
          </div>

          {/* Légal - avec liens vers vraies pages */}
          <div>
            <h4 className="font-semibold text-white mb-4">Légal</h4>
            <ul className="space-y-2">
              <li><Link to="/legal/privacy" className="text-[#AAAAAA] hover:text-[#F97316] transition">Politique de confidentialité</Link></li>
              <li><Link to="/legal/terms" className="text-[#AAAAAA] hover:text-[#F97316] transition">Conditions d'utilisation</Link></li>
              <li><Link to="/legal/legal-notice" className="text-[#AAAAAA] hover:text-[#F97316] transition">Mentions légales</Link></li>
              <li><Link to="/legal/cookies" className="text-[#AAAAAA] hover:text-[#F97316] transition">Politique des cookies</Link></li>
              <li><Link to="/legal/gdpr" className="text-[#AAAAAA] hover:text-[#F97316] transition">RGPD</Link></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="font-semibold text-white mb-4">Newsletter</h4>
            <p className="text-[#AAAAAA] mb-4">Recevez nos actualités et offres exclusives</p>
            <form className="flex" onSubmit={(e) => e.preventDefault()}>
              <input
                type="email"
                placeholder="votre@email.com"
                className="flex-1 px-4 py-3 rounded-l-xl bg-[#1a1a1a] border border-[#252525] text-white placeholder-[#666666] focus:outline-none focus:ring-1 focus:ring-[#F97316]"
                required
              />
              <button 
                type="submit"
                className="bg-[#F97316] text-white px-5 py-3 rounded-r-xl hover:bg-[#ea580c] transition font-medium"
              >
                OK
              </button>
            </form>
            <p className="text-xs text-[#666666] mt-3">
              En vous inscrivant, vous acceptez de recevoir nos emails.
            </p>
          </div>
        </div>

        <div className="border-t border-[#252525] mt-12 pt-8 text-center text-[#666666] text-sm">
          <p>© {new Date().getFullYear()} VADOM. Tous droits réservés.</p>
          <p className="mt-1">
            <Link to="/legal/terms" className="hover:text-[#F97316] transition">Conditions</Link>
            {' · '}
            <Link to="/legal/privacy" className="hover:text-[#F97316] transition">Confidentialité</Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;